const FamilyAndLovedOnesIcon = props => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={32}
    height={32}
    viewBox='0 0 32 32'
    fill='none'
    {...props}>
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={0.9}
      d='M10.144 22.32v6.964M6.712 20.1H5.606c-.87 0-1.576-.692-1.576-1.544L4 12.619c-.007-1.23 1.009-2.23 2.264-2.232l6.294-.01M7.388 4.854c0 1.81 1.216 3.316 2.719 3.316s2.719-1.506 2.719-3.316S11.609 2 10.106 2C8.605 2 7.389 3.044 7.389 4.854ZM13.603 29.198V17.282M13.57 21.49h-.552c-.792 0-1.434-.628-1.434-1.403v-4.191c0-.897.744-1.624 1.66-1.624l6.409.005c.915 0 1.656.727 1.656 1.624v4.185c0 .775-.642 1.404-1.434 1.404h-.552'
    />
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={0.9}
      d='M25.391 23.63v4.397c0 .71-.588 1.287-1.314 1.287H8.026c-.726 0-1.314-.577-1.314-1.287V13.632M22.32 29.082v-5.334'
    />
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={0.9}
      d='M19.266 23.619h7.916c.013 0 .021-.01.02-.022l-1.808-9.625'
    />
    <path
      stroke='currentColor'
      strokeMiterlimit={10}
      strokeWidth={0.9}
      d='m26.332 19.124.711-.115c.955-.154 1.593-1.048 1.414-1.978l-.756-3.913-.03-.142c-.29-1.16-1.388-1.951-2.607-1.951h-4.57M24.79 5.777c0 1.622-1.093 3.102-2.438 3.102s-2.437-1.48-2.437-3.102c0-1.623 1.092-2.559 2.437-2.559s2.437.936 2.437 2.559ZM14.456 9.95c0 1.284.863 2.414 1.928 2.414 1.066 0 1.928-1.13 1.928-2.414 0-1.283-.863-2.024-1.928-2.024s-1.928.74-1.928 2.024ZM19.235 29.198V17.282M16.386 23.828v5.456'
    />
  </svg>
)

export default FamilyAndLovedOnesIcon
